<div
  class="availability-edit-dialog"
  data-cy="availability-edit-dialog">
  <div class="dialog-header">
    <app-availability-icon
      class="availability-icon"
      [availability]="data.availability"></app-availability-icon>
    <h1 mat-dialog-title>
      {{ data.availability.date | date: "EEEE, dd.MM.yyyy" }}
    </h1>
  </div>
  <div mat-dialog-content>
    <div class="availability-day-toggle-row">
      <div class="toggle-label">
        {{ ("availability" | i18n) || "Verfügbarkeit" }}
      </div>
      <app-toggle-buttons
        [disabled]="!(canUpdateAvailabilities$ | async)"
        [trueLabel]="('available' | i18n) || 'available' | titlecase"
        [falseLabel]="('unavailable' | i18n) || 'unavailable' | titlecase"
        [value]="data.availability.isAvailable"
        (valueChange)="toggleDayAvailability($event)"
        data-cy="day-toggle-buttons"></app-toggle-buttons>
    </div>
  </div>
  <app-availability-shift-toggle-list
    class="shift-toggle-list"
    [disabled]="!(canUpdateAvailabilities$ | async)"
    [availability]="data.availability"
    (shiftToggled)="toggleShift($event)"></app-availability-shift-toggle-list>

  <div
    class="note-edit"
    *ngIf="isEditingNote">
    <textarea
      matInput
      [placeholder]="('description' | i18n) || 'description' | titlecase"
      [(ngModel)]="noteText"
      name="description"
      rows="7"
      data-cy="edit-availability-dialog-note-input"
      class="note-textarea">
    </textarea>
  </div>
  <div
    mat-dialog-actions
    class="dialog-actions">
    <button
      *ngIf="!isEditingNote; else saveNoteButton"
      (click)="editNote($event)"
      type="button"
      class="bordered-button"
      data-cy="availability-edit-dialog-edit-note-button"
      [disabled]="!(canUpdateAvailabilities$ | async)"
      mat-button>
      <ng-container *ngIf="noteText; else addNoteButtonText">
        {{ ("editNote" | i18n) || "Notiz bearbeitens" | uppercase }}
      </ng-container>
      <ng-template #addNoteButtonText>
        {{ ("addNote" | i18n) || "Notiz hinzufügens" | uppercase }}
      </ng-template>
    </button>
    <ng-template #saveNoteButton>
      <button
        (click)="saveNote($event)"
        [disabled]="!(canUpdateAvailabilities$ | async)"
        type="button"
        class="bordered-button save-note-button"
        data-cy="availability-edit-dialog-save-note-button"
        mat-button>
        {{ ("saveNote" | i18n) || "Notiz speichern" | uppercase }}
      </button>
    </ng-template>
    <div class="flex-spacer"></div>
    <button
      mat-button
      class="bordered-button"
      data-cy="availability-edit-dialog-close-button"
      (click)="cancel()">
      {{ ("close" | i18n) || "Schliessen" | uppercase }}
    </button>
  </div>
</div>
